import { useCallback, useEffect, useState } from "react";
import useCookie from "../../hooks/useCookie";
import useModalActions from "../../hooks/useModalActions";
import { MODAL_TYPES } from "../../utils/emitter";

export default function useViewController() {
  const [isTermsAccept, setIsTermsAccept] = useState(false);
  const [isPrivacyAccept, setIsPrivacyAccept] = useState(false);
  const [currentStep, setCurrentStep] = useState(1);
  const { getCookie } = useCookie();
  const { openModal } = useModalActions();

  const onCheckTerms = useCallback(() => {
    setIsTermsAccept(!isTermsAccept);
  }, [isTermsAccept]);

  const onCheckPrivacy = useCallback(() => {
    setIsPrivacyAccept(!isPrivacyAccept);
  }, [isPrivacyAccept]);

  useEffect(() => {
    const invitedValue = getCookie("isInvited");
    if (+invitedValue === 1) {
      openModal(MODAL_TYPES.FIRST_TIME_PLAYING);
    }
  }, []);

  return {
    onCheckTerms,
    isTermsAccept,
    onCheckPrivacy,
    isPrivacyAccept,
    currentStep,
    onSetNextStep: () => setCurrentStep((prevState) => prevState + 1),
  };
}
